// src/components/providers/ReduxProvider.tsx
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '.';
import { setupAutoSessionRefresh } from '../utils/sessionManager';

interface ReduxProviderProps {
	children: React.ReactNode;
}

const ReduxProvider: React.FC<ReduxProviderProps> = ({ children }) => {
	useEffect(() => {
		// Setup automatic session refresh when the app loads
		const cleanup = setupAutoSessionRefresh();

		// Cleanup on unmount
		return cleanup;
	}, []);

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				{children}
			</PersistGate>
		</Provider>
	);
};

export default ReduxProvider;